import { BalikovnaPickupPoint } from 'skladon-types';

export const formatData = (data: BalikovnaPickupPoint[]) => {
    return data.map((item) => ({
        label: `${item.street} ${item.houseNumber}/${item.orientationNumber}, ${item.cityPart}, ${item.postCode}, ${item.name}`,
        value: item.postCode
    }));
};
